import { OrderTransport } from "src/app/transports/order";
import PublishGrid from "./PublishGrid";

const PublishGridBlog = () => {
    return <PublishGrid listHandler={OrderTransport.publish.blog.list} />;
};

export default PublishGridBlog;
